import React, {Component} from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, AutoComplete, Select, Checkbox} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import {NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import EditForm from './EditForm.js';
import ViewForm from './ViewForm.js';
import css from './index.css';
import AuditForm from './AuditForm';
import {getLoginUser, hasAuth} from '../../../utils/NHCore';

const confirm = Modal.confirm;

const baseUrlPath = "/swbl/lstd"; //基础路径
const ztxyUrlPath = "/ztxy/swbl/lstd"; //基础路径
const jfxtBasicUrl = 'api/zhxg-jfxt/';
/**
 * 绿色通道列表
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap: {
                tableFlag: true,
                addFlag: false,
                updateFlag: false,
                viewFlag: false,
                auditFlag: false,
                dkgzFlag:false,
            },
            autoCompleteData: [],
            columnName: 'XH',
            statu:'',
            checked: true,
            tableShowFlag: false,
        };
    }

    componentWillReceiveProps(next){
        if(next.dqnd){
            this.setState({
                dqnd: next.dqnd,
                tableShowFlag: true,
            },()=>{
                this.refs.nhTable.filterTableData();
            })
        }
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }
    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }
    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setState({formInitData: {}});
        this.setCurrentPageShow('addFlag');
    }
    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        this.setState({formInitData: record}, () => {
            this.setCurrentPageShow('updateFlag');
        });
    }
    //审核按钮点击时间
    handleAuditBtnClick = (record) => {
        this.setState({formInitData: record}, () => {
            this.setCurrentPageShow('auditFlag');
        })
    }
    //查看按钮点击事件
    handleViewBtnClick = (record) => {
        console.log(record)
        this.setState({formInitData: record});
        this.setCurrentPageShow('viewFlag');
    }
    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        NHConfirm("是否确定删除这条数据？", () => {
            let pkid = record.PKID;//TODO 把此处的信息改成自己的
            if (record.SHZT == '1') {
                message.warning("审核通过的数据不能删除！");
                return;
            }
            this.handleDelete([record]);
        }, "warn");
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        let selectedRows = this.refs.nhTable.state.selectedRows;

        if (selectedRowKeys && selectedRowKeys.length > 0) {
            let isFlag = true;
            for (let row of selectedRows) {
                if (row.SHZT == '审核通过') {
                    isFlag = false;
                }
            }
            if (isFlag) {
                NHConfirm("是否确定删除选中的多条数据？", () => {
                    this.handleDelete(selectedRows);
                }, "warn");
            } else {
                message.warning("审核通过的数据不能直接删除！您可以先撤销再删除");
            }
        } else {
            message.warning("请先选择需要删除的数据！");
        }
    }
    //删除操作
    handleDelete = (pkids) => {
        NHFetch(ztxyUrlPath + '/deleteByPoMap', 'POST', pkids)
            .then(res => {
                if (res) {
                    message.success("删除操作成功！");
                    this.refs.nhTable.readTableData();
                }
            })
    }
    //单行撤销
    handleBackoutBtnClick = (record) => {
        NHConfirm("是否确定撤销这条数据？", () => {
            let pkid = record.PKID;//TODO 把此处的信息改成自己的
            this.handleBackout([pkid]);
        }, "warn");
    }
    //撤销操作
    handleBackout = (pkids) => { 
        NHFetch(ztxyUrlPath + '/operateBackout', 'POST', pkids)
            .then(res => {
                if (res) {
                    message.success("撤销操作成功！");
                    this.refs.nhTable.readTableData();
                }
            })
    }
    //新增面板保存方法
    handleSaveAdd = () => {
        this.refs.nhAddForm.validateFields((err, formData) => {
            const xsid = formData['xsid'];
            const nd = formData['nd'];
            if (!xsid && !nd) {
                message.warning('未获取学生信息，请刷新重试。');
                return;
            }
            if (err) {
                return;
            }
            let params = formData;
            let yhbh = getLoginUser() ? getLoginUser().userId : '';
            params['yhbh'] = yhbh;
            NHFetch(ztxyUrlPath + '/insert', 'POST', params)
                .then(res => {
                    if (res) {
                        message.success("新增绿色通道成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.readTableData();
                    }
                })
        });
    }
    //修改面板保存方法
    handleSaveUpdate = () => {
        this.refs.nhUpdateForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            const xsid = formData['xsid'];
            const nd = formData['nd'];
            if (!xsid && !nd) {
                message.warning('未获取学生信息，请刷新重试。');
                return;
            }
            let params = formData;
            NHFetch(ztxyUrlPath + '/update', 'POST', params)
                .then(res => {
                    if (res) {
                        message.success("修改绿色通道成功！");//TODO 把此处的信息改成自己的
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.readTableData();
                    }
                })
        });
    }
    //审核保存方法
    handleSaveAudit = () => {
        let yhbh = getLoginUser() ? getLoginUser().userId : '';
        this.refs.nhAuditForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let data = formData;
            data['yhbh'] = yhbh;
            NHFetch(ztxyUrlPath + '/operateAudit', 'POST', data)
            .then(res => {
            if (res.code===200) {
                message.success("审核绿色通道成功！");
                this.setCurrentPageShow('tableFlag');
                this.refs.nhTable.readTableData();
            }
            })       
            });
    }
    handleSearch = () => {
        if (this.state.columnValue) {
            NHFetch(ztxyUrlPath + '/getYxxsByKey', 'get', {
                columnName: this.state.columnName,
                value: this.state.columnValue
            }).then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        if(data.length===0){
                            this.setState({statu:'该学生不存在或该学生已添加！'},()=>{
                                this.setState({autoCompleteData: data});
                            })
                        }else{
                            this.setState({statu:''},()=>{
                                this.setState({autoCompleteData: data});
                            })
                        }
                    } else {
                        this.setState({autoCompleteData: []});
                    }
                }
            });
        } else {
            this.setState({autoCompleteData: []});
        }
    }
    handleChange = (value) => {
        NHFetch(baseUrlPath + '/getYxxsByUnion', 'get', {columnName: this.state.columnName, value: value}).then(res => {
            if (res) {
                this.setState({formInitData: res.data}, () => {
                    this.refs.nhAddForm.resetFields(['xsid']);
                });
            }
        });
    }
    buildAutoComplete = (autoCompleteData) => autoCompleteData.map((item,key)=> {
        if(key<10){//限制显示10条，，数据过多页面卡顿
          return <AutoComplete.Option key={item.VALUE}>{item.TEXT}</AutoComplete.Option>
        }
    });

    //导出绿色通道信息
    handleOutPcXx =() =>{
        this.refs.nhTable.exportExcel('绿色通道信息');
    }

    //勾选当前年度复选框
    onChange = (e) => {
        let { tableShowFlag } = this.state;
        if(e.target.checked) {
            tableShowFlag: true;
        }else {
            tableShowFlag: false;
        }
        this.setState({
          checked: e.target.checked,
          tableShowFlag: tableShowFlag,
        }, ()=>{
            this.refs.nhTable.filterTableData();
        });
    };

    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '60px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '100px',
                searchType:"input"
            }, {
                title: '性别',
                dataIndex: 'XB',
                width: '70px',
                searchType:"select"
            }, {
                title: '学院',
                dataIndex: 'BMMC',
                width: '100px',
                searchType:"select"
            }, {
                title: '专业',
                dataIndex: 'ZYMC',
                width: '100px',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                dataIndex: 'BJMC',
                width: '100px',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '年度',
                dataIndex: 'ND',
                width: '100px',
                searchType:"select",
            },{
                title: '缓交金额',
                dataIndex: 'HJJE',
                width: '100px',
                searchType:"select",
            },{
                title: '缓交期限',
                dataIndex: 'HJQX',
                width: '100px',
                searchType:"select",
            },{
                title: '缓交学费',
                dataIndex: 'XFHJ',
                width: '100px',
            },{
                title: '缓交住宿费',
                dataIndex: 'ZSFHJ',
                width: '100px',
            },{
                title: '办理原因',
                dataIndex: 'SQSM',
                width: '200px',
            },{
                title: '审核状态',
                dataIndex: 'SHZT',
                width: '100px',
                fixed: 'right',
                searchType:"select"
            }
        ];
        //行内操作
        const action = [
             {
                title: '修改', onClick: this.handleUpdateBtnClick,isShow: (record) => {
                     if (record.SHZT == '未审核') {
                        return true;
                     }
                     return false;
                 },
                auth: 'zhxg_yxgl_swbl_lstd:update'
            },
            {
                title: '审核', onClick: this.handleAuditBtnClick, isShow: (record) => {
                    if (record.SHZT == '未审核') {
                        return true;
                    }
                    return false;
                }
                , auth: 'zhxg_yxgl_swbl_lstd:review'
            },
            {
                title: '撤销', onClick: this.handleBackoutBtnClick, isShow: (record) => {
                    if (record.SHZT == '审核通过') {
                        return true;
                    }
                    return false;
                }
                , auth: 'zhxg_yxgl_swbl_lstd:review'
            },
            {title: '查看', onClick: this.handleViewBtnClick, auth: 'zhxg_yxgl_swbl_lstd:detail'}
        ];
        let autoCompleteData = this.state.autoCompleteData;
        const { tableShowFlag } = this.state;
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                {tableShowFlag ? 
                <div className={css.table} style={{display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none'}}>
                    <NHTable ref='nhTable'
                            rowKey={record => record.PKID}
                            sign={"ztxy_yxfw_swbl_lstd"}
                            columns={columns}
                            action={action}
                            rangeFilter={true}
                            initParams={this.state.checked ? {S_ND_EQ : this.state.dqnd} : {}}
                    >
                        {
                            hasAuth('zhxg_yxgl_swbl_lstd:add') ?
                                <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>
                                : null
                        }
                        {
                            hasAuth('zhxg_yxgl_swbl_lstd:delete') ?
                                <Button type="danger" ghost style={{marginLeft: 10}}
                                        onClick={this.handleMultiDeleteBtnClick}>删除</Button>
                                : null
                        }
                        {hasAuth('zhxg_yxgl_swbl_lstd:export') ?<Button type="primary" onClick={this.handleOutPcXx} style={{ marginLeft: 10 }}>导出</Button>:undefined}
                        <Checkbox checked={this.state.checked} onChange={this.onChange} style={{marginLeft:'10px',fontSize:'14px'}}>当前年度</Checkbox>
                    </NHTable>
                </div>
                : null}
                <NHContainerFrame ref="nhAddModal"
                                  title="新增绿色通道"
                                  visible={this.state.frameVisibleMap.addFlag}
                                  onOk={this.handleSaveAdd}
                                  onCancel={this.handleCloseFrame}
                >
                    <Row style={{marginBottom: '24px', fontSize: '14px', lineHeight: '1.5'}}>
                        <Col span={4} style={{textAlign: 'right'}}>
                            <Select defaultValue={this.state.columnName} style={{width: '100px'}}
                                    onChange={(value) => {
                                        this.setState({columnName: value}, this.handleSearch);
                                    }}>
                                <Select.Option value='XH'>学号</Select.Option>
                                <Select.Option value='KSH'>考生号</Select.Option>
                                <Select.Option value='ZKZH'>准考证号</Select.Option>
                                <Select.Option value='LQH'>录取号</Select.Option>
                                <Select.Option value='SFZJH'>身份证件号</Select.Option>
                            </Select>
                        </Col>
                        <Col span={20}>
                            <AutoComplete
                                style={{marginLeft: '10px', width: '200px'}}
                                onSearch={(value) => {
                                    this.setState({columnValue: value}, this.handleSearch);
                                }}
                                onSelect={this.handleChange}
                                placeholder={"请输入查询条件"}
                            >
                                {this.buildAutoComplete(autoCompleteData)}
                            </AutoComplete><span style={{ color: 'red' }}>{this.state.statu}</span>
                        </Col>
                        
                    </Row>
                    <EditForm ref="nhAddForm" initFormData={this.state.formInitData}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhUpdateModal"
                                  title="修改绿色通道"
                                  visible={this.state.frameVisibleMap.updateFlag}
                                  onOk={this.handleSaveUpdate}
                                  onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhUpdateForm" initFormData={this.state.formInitData}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhShowModal"
                                  visible={this.state.frameVisibleMap.viewFlag}
                                  title="查看绿色通道" //TODO 把此处的信息改成自己的
                                  onCancel={this.handleCloseFrame}
                                  footer={[]}
                >
                    <ViewForm initFormData={this.state.formInitData}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhAuditModal"
                                  visible={this.state.frameVisibleMap.auditFlag}
                                  title="审核绿色通道" //TODO 把此处的信息改成自己的
                                  onCancel={this.handleCloseFrame}
                                  onOk={this.handleSaveAudit}
                >
                    <AuditForm ref="nhAuditForm" initFormData={this.state.formInitData}/>
                </NHContainerFrame>
            </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./components/swbl/ztxyLstd/index.js